import React from 'react';
import { Link, Meta, Title } from 'react-head';
import { useLanguageURLRoots, languageURLRoots, origin } from '../../config';
import { translate } from '../../utils/locale';
import { urlify } from '../../utils/string';

const Top = ({ setup, pageContent = {}, paths, skipGeneral = false, locationType }) => {
	const titlePrefix = translate(setup, 'titlePrefix', 'meta');
	const titleSuffix = translate(setup, 'titleSuffix', 'meta');
	const defaultLanguage = setup.languages?.default?.language || Object.keys(setup.languages)?.[0]?.language || 'default';
	const tags = {};

	if (paths && Object.keys(paths).length > 1) {
		Object.keys(paths).forEach((lang) => {
			const pathLanguage = paths[lang];
			if (lang === 'default') lang = defaultLanguage;
			// News exists but is not that page.
			if (pathLanguage && ((pathLanguage.indexOf('new-arrivals') !== -1 && pathLanguage !== 'new-arrivals') || (pathLanguage.indexOf('nyinkommet') !== -1 && pathLanguage !== 'nyinkommet'))) {
				tags.metaRobots = <Meta key="metaRobots" name="robots" content="noindex" />;
			}
			const repeatVariations = setup.languageVariations ? Object.keys(setup.languageVariations).filter((l) => l.indexOf(lang) === 0) : [];

			if (pathLanguage === '' || pathLanguage === 'start' || locationType === 'START') {
				if (useLanguageURLRoots && languageURLRoots[lang]) {
					tags[`linkAlternate${lang}`] = <Link key={`linkAlternate${lang}`} rel="alternate" hrefLang={lang} href={`https://${languageURLRoots[lang][0]}`} />;
					if (repeatVariations) {
						repeatVariations.forEach((l) => {
							tags[`linkAlternate${l}`] = <Link key={`linkAlternate${l}`} rel="alternate" hrefLang={l} href={`https://${languageURLRoots[l][0]}`} />;
						});
					}
				} else {
					tags[`linkAlternate${lang}`] = <Link key={`linkAlternate${lang}`} rel="alternate" hrefLang={lang} href={`${origin}/${lang}`} />;
				}
			} else if (!pageContent.restrict || (pageContent.restrict && pageContent.restrict.indexOf(lang) === -1)) {
				if (useLanguageURLRoots && languageURLRoots[lang]) {
					tags[`linkAlternate${lang}`] = <Link key={`linkAlternate${lang}`} rel="alternate" hrefLang={lang} href={`https://${languageURLRoots[lang][0]}/${pathLanguage}`} />;
					if (repeatVariations) {
						repeatVariations.forEach((l) => {
							tags[`linkAlternate${l}`] = <Link key={`linkAlternate${l}`} rel="alternate" hrefLang={l} href={`https://${languageURLRoots[l][0]}/${pathLanguage}`} />;
						});
					}
				} else {
					tags[`linkAlternate${lang}`] = <Link key={`linkAlternate${lang}`} rel="alternate" hrefLang={lang} href={`${origin}/${lang}/${pathLanguage}`} />;
				}
			}
		});
	}

	Object.keys(pageContent).forEach((tag) => {
		const text = translate(setup, pageContent[tag]);
		if (tag.indexOf('meta') === 0 && text !== '') {
			tags[tag] = <Meta key={tag} name={tag.replace('meta', '').toLowerCase()} content={text} />;
		} else if (tag.indexOf('link') === 0) {
			tags[tag] = <Link key={tag} rel={tag.replace('link', '').toLowerCase()} href={text} />;
		}
	});
	const metaDescription = pageContent.metaDescription ? pageContent.metaDescription : setup.meta.defaultMetaDescription;
	if (pageContent.title && !pageContent.title.text) pageContent.title = { text: pageContent.title };
	const title = `${skipGeneral || titlePrefix === 'titlePrefix' ? '' : `${titlePrefix} `}${pageContent.title ? translate(setup, pageContent.title) : ''}${skipGeneral || titleSuffix === 'titleSuffix' ? '' : ` ${titleSuffix}`}`;

	tags['og:type'] = <Meta key="ogType" property="og:type" content="website" />;
	tags['og:title'] = <Meta key="ogTitle" property="og:title" content={title} />;
	tags['og:description'] = <Meta key="ogDescription" property="og:description" content={translate(setup, metaDescription)} />;
	if (pageContent.images) tags['og:image'] = pageContent.images.map((image) => <Meta key={`ogImage-${urlify(image.slice(image.lastIndexOf('/')))}`} name={`ogImage-${urlify(image.slice(image.lastIndexOf('/')))}`} property="og:image" content={image} />);
	if (pageContent.canonical) tags['og:url'] = <Meta key="ogUrl" property="og:url" content={pageContent.canonical} />;


	return (
		<>
			<Title>{ title }</Title>
			{
				Object.keys(tags).map((tag) => {
					if (tag === 'metaDescription') return <Meta key="metaDescription" name="description" content={translate(setup, metaDescription)} />;
					return tags[tag];
				})
			}
		</>
	);
};

export default Top;
